module.exports = __webpack_public_path__ + "img/austria-stomach-cancer-male.5722e409.png";